<div class="p-3 d-flex gap-3 flex-column overtime-summary-activity" *transloco="let t; prefix: 'overtimeManagement'">
  <div class="d-flex align-items-center overtime-summary-activity-header">
    <div class="flex-grow-1">
      <h4 class="fw-bold">{{ t('activity.title') }}</h4>
    </div>
  </div>

  <div class="row gx-1">
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('activity.requested')"
        [value]="overtimeActivitySummary.requestedCurrentValue"
        [difference]="overtimeActivitySummary.requestedDifference"
        [percentageDifference]="overtimeActivitySummary.requestedPercentageDifference"
        [dateInterval]="this.dateFilter.interval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('activity.accepted')"
      [value]="overtimeActivitySummary.acceptedCurrentValue"
        [difference]="overtimeActivitySummary.acceptedDifference"
        [percentageDifference]="overtimeActivitySummary.acceptedPercentageDifference"
        [dateInterval]="this.dateFilter.interval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="t('activity.rejected')"
        [value]="overtimeActivitySummary.rejectedCurrentValue"
        [difference]="overtimeActivitySummary.rejectedDifference"
        [percentageDifference]="overtimeActivitySummary.rejectedPercentageDifference"
        [dateInterval]="this.dateFilter.interval">
      </app-metric-block>
    </div>
    <div class="col-md-3 col-sm-6 overtime-summary-activity-item">
      <app-metric-block [isLoading]="isLoading" [title]="'common.pending' | transloco"
        [value]="overtimeActivitySummary.pendingCurrentValue"
        [difference]="overtimeActivitySummary.pendingDifference"
        [percentageDifference]="overtimeActivitySummary.pendingPercentageDifference"
        [dateInterval]="this.dateFilter.interval">
      </app-metric-block>
    </div>
  </div>
</div>